import { menuAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(menuAnatomy.keys);

export const menuTheme = defineMultiStyleConfig({
    baseStyle: definePartsStyle({
        list: {
            borderRadius: 0,
            bg: 'grayDark',
            borderColor: 'black',
            p: 0,
            borderBottom: 'none',
        },

        item: {
            color: 'white',
            bg: 'grayDark',
            borderBottom: '1px solid',
            borderBottomColor: 'black',
            padding: '6px 8px',
            _hover: {
                bg: 'gray.600',
            },
            _focus: {
                bg: 'grayDark',
            },
        },
        groupTitle: {
            bg: '#6d737f',
            opacity: 0.7,
            textTransform: 'uppercase',
            m: 0,
            px: 3,
            py: 1,
            letterSpacing: '2px',
            fontSize: '10px',
            borderBottom: '1px solid',
            borderBottomColor: 'black',
        },
    }),
});
